import { useRef, useCallback, useEffect } from 'react';

function useDebounce(predicate) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var timeout = useRef();
  var callback = useRef(predicate);
  var set = useCallback(function () {
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(function () {
      callback.current();
    }, delay);
  }, [delay]);
  var clear = useCallback(function () {
    timeout.current && clearTimeout(timeout.current);
  }, []);
  useEffect(function () {
    callback.current = predicate;
  }, [predicate]);
  useEffect(function () {
    return clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay]);
  return [set, clear];
}

export { useDebounce };
//# sourceMappingURL=useDebounce.js.map
